<template>
  <v-card flat class="showOnlyPrint">
    <v-card-text>
      <template>
        <div class="areaImprimir">
          <table class="mytable" width="100%">
            <tr>
              <td ><strong style="font-size: 1.5em"> CAJA No: {{ user.cajero?.ventanilla }}</strong> </td>
              <td><strong style="font-size: 1.5em">FECHA Y HORA: {{ fecha  }}</strong></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em"> RESPONSABLE DE CAJA: {{ user.funcionario?.nombre_completo }}</strong></td>
            </tr>

          </table>
          <table class="mytable" width="100%" >
            <tr>
              <td colspan="2" ><div style="font-size: 1.5em">TOTAL RECAUDO POR SERVICIO DE AGUA POTABLE</div></td>
              <td ><div style="font-size: 1.5em;text-align: right">{{ resumen.totalConsumoAgua | round }} Bs.</div></td>
            </tr>
            <tr>
              <td colspan="2" ><div style="font-size: 1.5em">TOTAL RECAUDO POR OTROS INGRESOS</div></td>
              <td ><div style="font-size: 1.5em;text-align: right">{{ resumen.totalOtroIngreso | round }} Bs.</div></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em"> TOTAL GENERAL</strong></td>
              <td ><div style="font-size: 1.5em;text-align: right">{{ total | round }} Bs.</div></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em"> TOTAL GENERAL ENTREGADO</strong></td>
              <td> <div  style="text-align: right;font-size: 1.5em">{{ (recaudacionStore.dinero) | round }} Bs.</div></td>
            </tr>
            <tr>
              <td colspan="3"><strong style="font-size: 1.5em"> Son: {{ literal }}</strong> </td>
            </tr>
          </table>
          <table class="mytable" width="100%">
            <tr>
              <td colspan="4" style="text-align: center"><strong style="font-size: 1.5em">CHEQUES RECIBIDOS DE CLIENTES</strong>
              </td>
            </tr>
            <tr style="font-size: 1.5em">
              <td style="font-size: 1.5em"> <strong style="font-size: 1.5em">Cheque No.</strong></td>
              <td><strong style="font-size: 1.5em">BANCO</strong></td>
              <td><strong style="font-size: 1.5em">GIRADO POR:</strong></td>
              <td><strong style="font-size: 1.5em">IMPORTE</strong></td>
            </tr>
            <tr v-for="(r,i) in recaudacionStore.cheques" :key="i">
              <td > <div style="font-size: 1.5em">{{i+1}}</div></td>
              <td > <div style="font-size: 1.5em"> {{ r.banco }}</div></td>
              <td > <div style="font-size: 1.5em">{{ r.girado }}</div></td>
              <td style="text-align: right"><div style="font-size: 1.5em">{{ r.importe }} Bs.</div></td>
            </tr>
            <tr>
              <td colspan="2" rowspan="2"><strong></strong></td>
              <td><strong style="font-size: 1.5em">TOTAL</strong></td>
              <td style="text-align: right"><strong style="font-size: 1.5em">{{chequesTotal}}</strong> Bs.</td>
            </tr>
            <tr>
              <td><strong style="font-size: 1.5em">TOTAL EFECTIVO Y CHEQUES</strong></td>
              <td style="text-align: right" ><strong style="font-size: 1.5em">{{sumando(chequesTotal,recaudacionStore.dinero)}}</strong> Bs.</td>
            </tr>
          </table>
          <table class="mytable" width="100%">
            <tr>
              <td colspan="3" style="text-align: center"><strong style="font-size: 1.5em">  CONTROL DE FACTURAS (SERV. DE AGUA
                POTABLE Y OTROS INGRESOS)</strong></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em">CANTIDAD FACTURAS COBRADAS DEL DÍA (SISTEMA)</strong></td>
              <td><strong style="font-size: 1.5em">{{ (sumNumber(resumen.cantidadFacturas , resumen.cantidadAnuladas)) | round }}</strong></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em">CANTIDAD FACTURAS CONSUMO DE AGUA</strong></td>
              <td><span style="font-size: 1.5em">{{ (resumen.cantidadFacturasConsumo) | round }}</span></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em">CANTIDAD FACTURAS OTRAS INGRESOS</strong></td>
              <td><span style="font-size: 1.5em">{{ (resumen.cantidadFacturasOtrosingresos) | round }}</span></td>
            </tr>
            <tr>
              <td colspan="2" > <strong style="font-size: 1.5em"> CANTIDAD DE FACTURAS ANULADAS EN EL SISTEMA</strong></td>
              <td><span style="font-size: 1.5em">{{ resumen.cantidadAnuladas | round }}</span></td>
            </tr>
            <tr>
              <td colspan="2"><strong style="font-size: 1.5em">CANTIDAD FACTURAS FÍSICAS COBRADAS DEL DÍA </strong></td>
              <td><strong style="font-size: 1.5em">{{ resumen.cantidadFacturas | round }}</strong></td>
            </tr>
          </table>
          <h4 align="justify">Los importes declarados y entregados, fueron recontados en mi presencia y recibidos en forma
            satisfactoria por el habilitado</h4>
          <br><br><br><br>
          <table width="100%">
            <tr>
              <td style="text-align: center">......................................................<br>Firma
                del Cajero<br>Entregué Conforme
              </td>
              <td style="text-align: center">......................................................<br>Firma
                Habilitado<br>Recibí Conforme
              </td>
            </tr>

          </table>
        </div>
      </template>

    </v-card-text>
  </v-card>



</template>

<script lang="ts">
import { recaudacionStore } from "@/store/recaudacionStore";
import {Component, Vue} from "vue-property-decorator";
import {globalStore} from "@/store/globalStore";
import { GlobalService } from "@/services/GlobalService";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import numbers from 'numeros_to_words';

@Component({
  name: "RecaudacionArqueo",
})

export default class RecaudacionArqueo extends Vue{
  private recaudacionStore = recaudacionStore();
  private globalStore = globalStore();

  get resumen(): any {
    return this.recaudacionStore.resumen;
  }
  sumando( num1: any,num2: any){
    const total = parseFloat(num1) + parseFloat(num2);
    if (isNaN(total)) {
      return 0;
    }
    return Math.round(total * 100) / 100;
  }

  get user(){
    return this.globalStore.user;
  }

  get fecha(){
    GlobalService.getInstance().getFecha();
    return this.globalStore.fecha;
  }

  get total(){
    const total = parseFloat(this.resumen.arqueoTotal);
    return Math.round(total * 100) / 100;
  }

  sumNumber(num1:any, num2:any){
    const total = parseFloat(num1) + parseFloat(num2);
    return Math.round(total * 100) / 100;
  }

  get literal(): string{
    numbers().Config._setSingular('BOLIVIANO');
    numbers().Config._setPlural('BOLIVIANOS');
    numbers().Config._setCentsSingular('CENTAVO');
    numbers().Config._setCentsPlural('CENTAVOS');

    return numbers(this.recaudacionStore.dinero).toString();
  }
  get chequesTotal(){
    let t=0;
    this.recaudacionStore.cheques.forEach(c=>{
      t+= parseFloat(c.importe)
    })
    return Math.round(t * 100) / 100;
  }
}
</script>

<style scoped>
.showOnlyPrint{
  display: none;
}
.em-2{
  font-size: 2em;
}
</style>
